import { OktaAuth } from '@okta/okta-auth-js';

const CLIENT_ID = '0oafueinvzo9xfT0m357';
const ISSUER = 'https://upl.okta.com';
const LOGIN_REDIRECT_URI = `${window.location.origin}/callback`;
const LOGOUT_REDIRECT_URI = window.location.origin;

const oktaAuth = new OktaAuth({
  clientId: CLIENT_ID,
  issuer: ISSUER,
  redirectUri: LOGIN_REDIRECT_URI,
  pkce: false,
});
export const useOktaAuth = () => {
  const isAuthenticated = async () => {
    return !!(await oktaAuth.tokenManager.get(
      'accessToken'
    ));
  };

  const login = () => {
    localStorage.setItem('isOktaUser', 'true');
    oktaAuth.token
      .getWithRedirect({
        scopes: ['openid', 'email', 'profile'],
      })
      .then(() => {
        // logEvent(customEvents.OKTA_REDIRECTION);
      });
  };

  const logout = async () => {
    await oktaAuth.signOut({
      postLogoutRedirectUri: LOGOUT_REDIRECT_URI,
    });
    localStorage.clear();
  };

  const getAccessToken = async () => {
    try {
      const tokenContainer =
        await oktaAuth.token.parseFromUrl();
      const accessToken =
        tokenContainer?.tokens?.accessToken?.accessToken;
      return accessToken;
    } catch (err) {
      return undefined;
    }
  };

  return { login, isAuthenticated, getAccessToken, logout };
};
